import React from 'react'
import PropTypes from 'prop-types'
import DhsvBlogTaxListing from './taxListing'
import './style.scss'

class DhsvBlogFilterBar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      stickyBar: false,
      searchTerm: '',
      showSearch: false,
    }

    this.ref = React.createRef()
    this.onScroll = this.onScroll.bind(this)
    this.handleClickSearch = this.handleClickSearch.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }

  onScroll() {
    const rect = this.ref.current.getBoundingClientRect()

    /*
    if (rect.top - 58 < rect.height * -1) {
      this.setState({ stickyBar: true })
    } else {
      this.setState({ stickyBar: false })
    } */

    this.setState({ stickyBar: rect.top <= 0 })
  }

  handleClickSearch() {
    this.setState({ showSearch: true })
  }

  handleKeyDown() {
    if (event.key === 'Enter') {
      this.setState({ showSearch: false })
    }
  }

  render() {
    const {
      strings,
      tax,
      handleSearchTermChange,
      handleCategoryChange,
      categories,
      logo,
      sBrowser,
      taxCombinations,
      current,
    } = this.props
    const { showSearch } = this.state

    console.log(tax)

    const { stickyBar, searchTerm } = this.state
    return (
      <React.Fragment>
        <div
          className={`dhsv_blog_filterbar ${
            stickyBar ? 'is-sticky' : ''
          } filterbar-background`}
          ref={this.ref}
        >
          <div className="search_wrapper">
            <input
              type="text"
              value={
                searchTerm ? searchTerm : strings.search ? strings.search : ''
              }
              onChange={e => {
                handleSearchTermChange(e)
                this.setState({ searchTerm: e.target.value.toLowerCase() })
              }}
              placeholder={strings.searchPlaceholder}
            />
          </div>
          <div className="filters">
            {tax.map((taxItem, index) => (
              <DhsvBlogTaxListing
                sBrowser={sBrowser}
                key={index}
                type={taxItem.type}
                title={taxItem.title}
                categories={categories}
                current={current}
                taxCombinations={taxCombinations}
                handleCategoryChange={handleCategoryChange}
              />
            ))}
          </div>
        </div>
        <div className="dhsv_fullbox">
          <div
            className={`dhsv_blog_filterbar -sticky ${stickyBar ? 'show' : ''}`}
          >
            <div className="container">
              <a className="logo_wrapper" href={'/'}>
                <img className="lazyload" data-src={logo} />
              </a>

              <div className="hide-onmobile">
                <div className="search_wrapper">
                  <input
                    type="text"
                    value={
                      searchTerm
                        ? searchTerm
                        : strings.search
                        ? strings.search
                        : ''
                    }
                    onChange={e => {
                      handleSearchTermChange(e)
                      this.setState({
                        searchTerm: e.target.value.toLowerCase(),
                      })
                    }}
                    placeholder={strings.searchPlaceholder}
                  />
                </div>
                <div className="filters d-flex">
                  {tax.map((taxItem, index) => (
                    <DhsvBlogTaxListing
                      sBrowser={sBrowser}
                      key={index}
                      type={taxItem.type}
                      title={taxItem.title}
                      categories={categories}
                      taxCombinations={taxCombinations}
                      handleCategoryChange={handleCategoryChange}
                    />
                  ))}
                </div>
              </div>
              {/*Mobile*/}
              <div className="show-onmobile filters">
                {!showSearch && (
                  <div
                    className="search_button"
                    onClick={this.handleClickSearch}
                  ></div>
                )}
                {showSearch && (
                  <div className="search_wrapper">
                    <input
                      type="text"
                      value={
                        searchTerm
                          ? searchTerm
                          : strings.search
                          ? strings.search
                          : ''
                      }
                      onChange={e => {
                        handleSearchTermChange(e)
                        this.setState({
                          searchTerm: e.target.value.toLowerCase(),
                        })
                      }}
                      placeholder={strings.searchPlaceholder}
                      onKeyDown={this.handleKeyDown}
                    />
                  </div>
                )}
                {!showSearch && (
                  <div className="filters d-flex">
                    {tax.map((taxItem, index) => (
                      <DhsvBlogTaxListing
                        sBrowser={sBrowser}
                        key={index}
                        type={taxItem.type}
                        title={taxItem.title}
                        categories={categories}
                        taxCombinations={taxCombinations}
                        handleCategoryChange={handleCategoryChange}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

DhsvBlogFilterBar.propTypes = {
  sBrowser: PropTypes.object,
  strings: PropTypes.object,
  handleSearchTermChange: PropTypes.func,
  handleDateChange: PropTypes.func,
  handleCategoryChange: PropTypes.func,
  dateRange: PropTypes.array,
  categories: PropTypes.array,
  tax: PropTypes.array,
  logo: PropTypes.string,
  taxCombinations: PropTypes.array,
  current: PropTypes.object,
}

export default DhsvBlogFilterBar
